module.exports = __webpack_public_path__ + "static/media/l-md10.598e027f.png";